<div *ngIf="subsidiaries$ | async as subsidiaries">
  <p-panel header="Subsidiaries" styleClass="drill-down-section-header" [toggleable]="true">
    <div>
      <p-table [value]="subsidiaries" styleClass="subsidiaries-table" [paginator]="true" [rows]="20" [alwaysShowPaginator]="false">
        <ng-template pTemplate="header">
          <tr class="subsidiaries-header-row">
            <th class="col-subsidiaries-name">Name</th>
            <th class="col-subsidiaries-id">ID</th>
            <th>Country</th>
            <th>Industry Codes</th>
            <th class="col-subsidiaries-type">Type</th>
            <th class="col-subsidiaries-percent">Direct %</th>
            <th class="col-subsidiaries-percent">Total %</th>
            <th>Oper Rev in million</th>
            <th>Total Assets in million</th>
            <th># of Empl.</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-subsidiary>
          <tr class="subsidiary-row">
            <td>
              {{ subsidiary.name }}
            </td>
            <td>
              {{ subsidiary.id }}
            </td>
            <td>
              {{ subsidiary.country }}
            </td>
            <td>
              {{ subsidiary.industryCodes }}
            </td>
            <td>
              {{ subsidiary.type }}
            </td>
            <td>
              {{ subsidiary.directPercent }}
            </td>
            <td>
              {{ subsidiary.totalPercent }}
            </td>
            <td>
              {{ subsidiary.operatingRevenue }}
            </td>
            <td>
              {{ subsidiary.totalAssets }}
            </td>
            <td>
              {{ subsidiary.numberOfEmployees }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr class="subsidiaries-no-result">
            <td [attr.colspan]="10" class="text-center">No results to display</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-panel>
</div>
